import { getLocalizedTextDefault, type LibraryQuestion } from "@/api/survey-library.service";

/**
 * Case-insensitive, in-memory substring filter over library questions.
 *
 * A question matches when the trimmed query is contained in EITHER its
 * `internalLabel` or the default localized question text (`text.default`).
 * An empty query returns the list unchanged.
 */
export function filterLibraryQuestions(
  questions: LibraryQuestion[],
  query: string,
): LibraryQuestion[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return questions;
  }

  return questions.filter(question => {
    const internalLabel = (question.internalLabel ?? "").toLowerCase();
    const text = getLocalizedTextDefault(question.text).toLowerCase();
    return internalLabel.includes(normalized) || text.includes(normalized);
  });
}
